(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["farmer-bio"] && !Shopify.designMode) return;
  try {
    
  const truncateElements = document.querySelectorAll('.truncate');

  truncateElements.forEach(element => {
  const readMore = element.querySelector('.read-more');
      if (element.offsetHeight < 40) {
          readMore.style.display = "hidden";
  }
      readMore.addEventListener('click', () => {
      element.classList.toggle('expanded');

      });
  });

  } catch(e) { console.error(e); }
})();
})();
